export const PRODUCT_FINDER_TABS = {
  FIND: 'find',
  RESPONSES: 'responses',
}

export const CLOSE_REASONS = {
  Found_Item: 'I found it',
  No_Longer_Needed: 'No longer needed',
  Price_too_high: 'Price too high',
  Did_not_get_the_price_I_wanted: 'Did not get the price I wanted',
  Not_Available: 'Not available',
  Other: 'Other',
}
